module.exports = __webpack_public_path__ + "static/img/newsg.495c0fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newsg.png
// module id = FHNJ
// module chunks = 45